




















import { Vue, Component } from "@/shared/vuepack";
import Heading from "../shared/Header.vue";
import AddEmployerUserForm from "@/shared/components/AddEmployerUserForm.vue";
import SettingsNavigation from "@/employer/components/settings/SettingsNavigation.vue";
import { useUserStore } from "@/shared/store/user";

@Component ({
  components: { Heading, SettingsNavigation, AddEmployerUserForm }
})
export default class Add extends Vue {
 userStore = useUserStore();
}
